import { makeStyles } from 'tss-react/mui';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import React, { useState } from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'react-uuid';
import { pageAttributesActions } from '../PlacementDetails/Edit/store/placementPageAttributes.redux';
import { selectExtensionModalProps } from '../PlacementDetails/Edit/store/placementPageAttributes.selector';
import { ExtensionForm } from './ExtensionForm';
import { selectPlacementStatus } from 'store/redux-store/placement-status/selectors';
import { selectPlacementHeaderData } from 'store/redux-store/placement-details/selectors';

const useStyles = makeStyles()({
  container: {
    width: '613px',
  },
  dialogActionRoot: {
    backgroundColor: '#F7F7F7',
  },
  dialogContentRoot: {
    overflowX: 'hidden',
  },
});

export const ExtensionModal = ({ ...props }) => {
  const { classes } = useStyles();
  const {
    open,
    title,
    isNewExtension,
    extensionStatus,
    extensionStatusId,
    extensionOverride,
    extContainerIndex,
    currentTargetField,
  } = useSelector(selectExtensionModalProps);
  const {
    extensionDetails: { endDateTravelerOption },
  } = useSelector(selectPlacementStatus);
  const { placementDate } = useSelector(selectPlacementHeaderData);
  const [formBtnAccessorId] = useState(uuid());
  const [hasBeenExpanded, setHasBeenExpanded] = useState(false);
  const dispatch = useDispatch();
  const { promiseInProgress } = usePromiseTracker({ area: 'update-extension-status', delay: 0 });
  const onClose = () => dispatch(pageAttributesActions.closeExtensionModal());
  const submitExtensionForm = () => document.getElementById(formBtnAccessorId)?.click();

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      draggable
      disableEnforceFocus
      dialogTitleProps={{
        text: title,
        expandable: true,
        closeButton: true,
        onExpandChange: expandedState => setHasBeenExpanded(expandedState),
      }}
      dialogActions={[
        {
          text: 'Cancel',
          variant: 'contained',
          color: 'tertiary',
          size: 'large',
          useDialogOnCloseEvent: true,
        },
        {
          text: 'Save',
          variant: 'contained',
          color: 'primary',
          size: 'large',
          disabled: !placementDate?.endDate,
          onClick: submitExtensionForm,
          loading: promiseInProgress,
        },
      ]}
      // dialogActionsProps={{ classes: { root: classes.dialogActionRoot } }}
      dialogContentProps={{ classes: { root: classes.dialogContentRoot } }}
      fullWidth
      maxWidth={'md'}
      classes={{
        paperFullWidth: hasBeenExpanded ? undefined : classes.container,
      }}
      variant="blue"
    >
      <ExtensionForm
        extensionStatus={extensionStatus}
        extensionStatusId={extensionStatusId}
        formBtnAccessorId={formBtnAccessorId}
        isNewExtension={isNewExtension}
        extensionOverride={extensionOverride}
        endDateTravelerOption={endDateTravelerOption}
        extContainerIndex={extContainerIndex}
        currentTargetField={currentTargetField}
        {...props}
      />
    </GenericDialog>
  );
};
